import styled from "styled-components";

export const Photo = styled.img`
  max-width: 100%;
  height: auto;
  -webkit-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  user-select: none;
`;
